<img class="dialog__img" srcset="{{assetsUrl}}/Portal/session-expired.jpg 1x, {{assetsUrl}}/Portal/session-expired@2x.jpg 2x">

<h1 class="mine-title-m dialog__title"> {{ 'authentication.sessionExpiredDialogTitle' | content }} </h1>

<p class="dialog__text"> {{ 'authentication.sessionExpiredDialogText' | content }} </p>

<mine-button-primary class="dialog__btn" (onClick)="signIn()">
    {{ 'authentication.sessionExpiredDialogBtn' | content }}
</mine-button-primary>
